<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout wrap>
            <v-flex xs8>
                <v-card>
                    <v-layout row>
                        <v-layout column class="ma-1 px-3">
                            <v-card-title class="pb-1 pt-2" primary-title>
                                <div>
                                    <div v-if="account.nonUTA">
                                        <v-layout
                                            row
                                            align-center
                                            class="pl-2 py-2"
                                        >
                                            <h3 class="headline my-0">
                                                Account ID:
                                                {{ account.accountID }}
                                            </h3>
                                            <div
                                                class="font-weight-medium ml-2 text-info"
                                            >
                                                Non UTA
                                            </div>
                                            <v-card-actions>
                                                <v-btn
                                                    small
                                                    @click="editAccount"
                                                    >Edit Account</v-btn
                                                >
                                            </v-card-actions>
                                        </v-layout>
                                    </div>
                                    <h3
                                        class="headline my-0"
                                        v-if="!account.nonUTA"
                                    >
                                        Account ID:
                                        {{ account.accountID }}
                                    </h3>
                                </div>
                            </v-card-title>
                            <v-card-text class="mb-0 pb-2 pt-0">
                                <h4 class="card-title font-weight-medium">
                                    {{ account.name }}
                                </h4>
                                <p>
                                    {{ account.hname }}
                                </p>
                                <p>
                                    {{ account.address1 }}
                                </p>
                                <br />
                                <div class="ml-2 mt-2">
                                    <v-layout row class="mb-2">
                                        <div class="font-weight-medium mr-2">
                                            Home:
                                        </div>
                                        <div>
                                            {{ account.homePhone }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="mb-2">
                                        <div class="font-weight-medium mr-2">
                                            Cell:
                                        </div>
                                        <div>
                                            {{ account.cellPhone }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="mb-2">
                                        <div class="font-weight-medium mr-2">
                                            Father:
                                        </div>
                                        <div>
                                            {{ account.father }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="mb-2">
                                        <div class="font-weight-medium mr-2">
                                            Father In Law:
                                        </div>
                                        <div>
                                            {{ ykAccount.fatherInLaw }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="mb-2">
                                        <div class="font-weight-medium mr-2">
                                            Email:
                                        </div>
                                        <div v-if="ykAccount.emailAddress">
                                            {{ ykAccount.emailAddress }}
                                        </div>
                                    </v-layout>
                                    <v-layout
                                        row
                                        class="mb-2"
                                        v-if="ykAccount.jlWebUsername"
                                    >
                                        <div class="font-weight-medium mr-2">
                                            Username:
                                        </div>
                                        <div>
                                            {{ ykAccount.jlWebUsername }}
                                        </div>
                                    </v-layout>
                                    <v-layout
                                        row
                                        class="mb-2"
                                        v-if="ykAccount.jlWebPassword"
                                    >
                                        <div class="font-weight-medium mr-2">
                                            Password:
                                        </div>
                                        <div>
                                            {{ ykAccount.jlWebPassword }}
                                        </div>
                                    </v-layout>
                                </div>
                            </v-card-text>

                            <v-card-actions class="pl-0">
                                <v-layout row wrap>
                                    <div class="pl-3 mt-1">
                                        <v-layout
                                            row
                                            class="mb-2 mt-2"
                                            v-if="ykAccount.jlWebPassword"
                                        >
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Link:
                                            </div>
                                            <a
                                                href="https://camp.yksw.org"
                                                target="_blank"
                                                class="website-link-text"
                                                >camp.yksw.org</a
                                            >
                                        </v-layout>

                                        <v-layout
                                            row
                                            class="mb-2"
                                            v-if="getRateCode()"
                                        >
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Rate Code:
                                            </div>
                                            <div>
                                                {{ getRateCode() }}
                                            </div>
                                        </v-layout>
                                    </div>
                                    <!-- <div class="pl-3">
                                        <v-layout row class="mb-2">
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                Lunch Doc Status:
                                            </div>
                                            <div>
                                                {{
                                                    ykAccount.lunchDocumentStatus
                                                }}
                                            </div>
                                        </v-layout>
                                        <v-layout
                                            row
                                            class="mb-2"
                                            v-for="student in getHealthFormStatus()"
                                        >
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                {{ student.name }}:
                                            </div>
                                            <div>
                                                {{ student.status }}
                                            </div>
                                        </v-layout>
                                        <v-layout
                                            row
                                            class="mb-2"
                                            v-for="student in getRegStatus()"
                                        >
                                            <div
                                                class="font-weight-medium mr-2"
                                            >
                                                {{ student.name }}:
                                            </div>
                                            <div>
                                                {{ student.status }}
                                            </div>
                                        </v-layout>
                                    </div> -->
                                    <v-spacer></v-spacer>
                                    <v-layout row justify-end class="mb-1 mr-1">
                                        <v-btn
                                            class="mt-3 mb-2 mr-1"
                                            color="success"
                                            small
                                            outline
                                            @click="editAccountInfo"
                                            >Edit Account Info</v-btn
                                        >
                                        <v-btn
                                            class="mt-3 mb-2 mr-1"
                                            color="success"
                                            small
                                            @click="emailCards"
                                            >Email Cards</v-btn
                                        >
                                        <v-btn
                                            class="mt-3 mb-2 mr-1"
                                            color="success"
                                            small
                                            :loading="printing"
                                            @click="printCards"
                                            >Print Cards</v-btn
                                        >
                                    </v-layout>
                                </v-layout>
                            </v-card-actions>
                        </v-layout>
                    </v-layout>
                </v-card>
                <transactions-list
                    :transactionsLoading="transactionsLoading"
                    :transactions="transactions"
                    :documents="documents"
                    :account="account"
                    :ykAccount="ykAccount"
                    :refresh="load"
                    :regID="regID"
                    :currentRegID="currentRegID"
                    :enrolledStudents="enrolledStudents"
                    :students="students"
                    :country="getCountry()"
                    :openDialogForStudent="openDialogForStudent"
                    :openPaymentModal="openPaymentModal"
                    :printStatement="printStatement"
                    :downloading="downloading"
                    :openEmailStatementDialog="openEmailStatementDialog"
                    :openNewCreditCardModal="openNewCreditCardModal"
                    :openUploadDocumentDialog="openUploadDocumentDialog"
                    :hasCopy="hasDocumetToCopy"
                    :openCopyDocumentDialog="openCopyDocumentDialog"
                ></transactions-list>
            </v-flex>
            <v-flex xs4 class="pa-0">
                <balance-details
                    :loading="balanceLoading"
                    :regID="regID"
                    :total="ykAccount.debit"
                    :previousBalance="ykAccount.previousBalance"
                    :paid="ykAccount.paid"
                    :credit="ykAccount.credit"
                    :scheduledPayments="ykAccount.scheduledPayments"
                    :actualBalance="ykAccount.actualBalance"
                    :totalPaid="ykAccount.totalPaid"
                    :balance="ykAccount.balance"
                    :pastYearsEnrollmentInfo="pastYearsEnrollmentInfo"
                    :account="ykAccount"
                ></balance-details>

                <payment-methods
                    :reloadPage="load"
                    :paymentMethods="paymentMethods"
                    :accountID="account.accountID"
                >
                </payment-methods>

                <notes
                    v-if="notesUrl"
                    :loadUrl="notesUrl"
                    :accountID="account.accountID"
                    :typeID="regID"
                    :showRequestType="true"
                    type="YKC"
                    ref="notes"
                ></notes>
                <!-- <v-card
                    class="pa-3 mt-3"
                    style="border: 3px solid rgb(92, 184, 96);"
                >
                    <v-btn
                        @click="openNewCreditCardModal()"
                        small
                        class=""
                        color="success"
                        >New Credit Card</v-btn
                    >
                    <v-card-actions class="mx-0">
                        <v-btn
                            class="mr-1"
                            color="success"
                            @click="openPaymentModal"
                        >
                            Make Payment
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            outline
                            color="success"
                            small
                            @click="printStatement"
                            >Print Statement</v-btn
                        >
                        <v-btn
                            outline
                            color="success"
                            small
                            @click="openEmailStatementDialog"
                            >Email Statement</v-btn
                        >
                    </v-card-actions>
                </v-card> -->
            </v-flex>
        </v-layout>

        <v-dialog v-model="newPaymentMethodDialog" max-width="400">
            <new-payment-method
                :accountID="account.accountID"
                :closeDialog="closeNewPaymentMethodDialog"
                :onSave="load"
                :hideBankAccount="true"
            ></new-payment-method>
        </v-dialog>

        <!-- <v-dialog
            persistent
            scrollable
            v-model="paymentDialog"
            max-width="1000"
        >
            <payment
                ref="paymentDialog"
                :paymentMethods="paymentMethods"
                :closePaymentDialog="closePaymentModal"
                :account="account"
                :ykAccount="ykAccount"
                :voucherAccount="voucherAccount"
                :refresh="load"
            ></payment>
        </v-dialog> -->
        <v-dialog persistent scrollable v-model="paymentDialog" max-width="800">
            <make-payment
                ref="paymentDialog"
                :paymentMethods="paymentMethods"
                :closePaymentDialog="closePaymentModal"
                :account="account"
                :ykAccount="ykAccount"
                :refresh="load"
                :processURL="processURL"
                :regID="regID"
                source="YK"
                categoryCode="YKC"
                categoryDescription="YK Camp"
            ></make-payment>
        </v-dialog>
        <v-dialog v-model="emailStatementDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline">Email Statement</v-card-title>
                <v-text-field
                    class="px-3"
                    v-model="emailAddress"
                    :rules="emailRules"
                    ref="emailStatement"
                    label="Email Address"
                ></v-text-field>
                <v-textarea
                    class="px-3 mb-3"
                    v-model="emailStatementMessage"
                    hide-details
                    label="Message"
                    rows="6"
                    ref="emailStatementMessage"
                ></v-textarea>

                <div
                    style="border: 1px solid #4caf50; overflow-y: auto; height: 250px;"
                    class="pa-2 mx-2"
                    v-if="includeNotesInEmail"
                >
                    <div v-html="getNotesForEmail()"></div>
                </div>

                <v-checkbox
                    class="mx-2 mt-3 mb-2 py-0"
                    label="Include Notes"
                    v-model="includeNotesInEmail"
                    hide-details
                    color="success"
                ></v-checkbox>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="default"
                        @click="emailStatementDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="emailing"
                        color="success"
                        @click="emailStatement"
                    >
                        Send
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="printCardsDialog" max-width="400">
            <v-card class="pa-2">
                <div>
                    <v-card-title class="text-warning headline"
                        >Are you sure?</v-card-title
                    >
                    <v-card-text
                        class="mb-2"
                        v-if="account.lunchDocumentStatus == 'MISSING'"
                    >
                        Lunch Document is missing:
                        <br />
                        {{
                            studentsMissingLunchDocuments()
                                .map((t) => t.student.name)
                                .join(", ")
                        }}
                    </v-card-text>
                    <div v-if="studentsMissingHealthFormDocuments().length">
                        <v-card-title class="text-danger headline"
                            >Missing Health Form</v-card-title
                        >
                        <v-card-text class="mb-2">
                            Health Forms are Missing for:
                            <br />
                            {{
                                studentsMissingHealthFormDocuments()
                                    .map((t) => t.student.name)
                                    .join(", ")
                            }}
                        </v-card-text>
                    </div>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="default" @click="printCardsDialog = false"
                            >Cancel</v-btn
                        >
                        <v-btn dark color="success" @click="print">
                            Print
                        </v-btn>
                    </v-card-actions>
                </div>
            </v-card>
        </v-dialog>
        <v-dialog v-model="emailCardsDialog" max-width="400">
            <v-card class="pa-2">
                <div>
                    <v-card-title class="headline">Email Cards</v-card-title>
                    <!-- <v-card-text
                        class="mb-2"
                        v-if="account.lunchDocumentStatus == 'MISSING'"
                    >
                        Lunch Document is missing:
                        <br />
                        {{
                            studentsMissingLunchDocuments()
                                .map((t) => t.student.name)
                                .join(", ")
                        }}
                    </v-card-text>
                    <div v-if="studentsMissingHealthFormDocuments().length">
                        <v-card-title class="text-danger headline"
                            >Missing Health Form</v-card-title
                        >
                        <v-card-text class="mb-2">
                            Health Forms are Missing for:
                            <br />
                            {{
                                studentsMissingHealthFormDocuments()
                                    .map((t) => t.student.name)
                                    .join(", ")
                            }}
                        </v-card-text>
                    </div> -->
                    <v-text-field
                        class="px-3"
                        ref="email"
                        v-model="emailAddress"
                        :rules="emailRules"
                        label="Email Address"
                    ></v-text-field>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            dark
                            color="default"
                            @click="emailCardsDialog = false"
                            >Cancel</v-btn
                        >
                        <v-btn
                            :loading="emailing"
                            color="success"
                            @click="sendEmail"
                        >
                            Send
                        </v-btn>
                    </v-card-actions>
                </div>
            </v-card>
        </v-dialog>

        <v-dialog v-model="uploadDocumentDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline">Upload Document</v-card-title>
                <v-select
                    class="px-3"
                    :items="documentTypes"
                    label="Document Type"
                    v-model="documentType"
                    ref="documentType"
                    :rules="rulesRequired"
                ></v-select>
                <v-layout row>
                    <v-btn
                        small
                        outline
                        :disabled="currentRegID != regID"
                        class="mr-2 ml-3 mb-4 mt-0"
                        :loading="uploading"
                        @click="pickFile()"
                    >
                        Upload
                        <v-icon right dark>mdi-cloud-upload</v-icon>
                    </v-btn>
                    <div v-if="files.length" class="mt-2 ml-2">
                        {{ files[0].name }}
                    </div></v-layout
                >
                <input
                    type="file"
                    style="display: none"
                    ref="files"
                    accept="image/*,.pdf"
                    @change="onFilePicked($event)"
                />
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="closeUploadDocumentDialog()"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :disabled="!files.length"
                        :loading="processing"
                        color="success"
                        @click="saveDocument()"
                    >
                        Save Document
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="copyDocumentDialog" max-width="800">
            <v-card class="pa-2">
                <v-card-title class="headline">Copy Document</v-card-title>
                <v-select
                    class="px-3"
                    :items="oldDocuments.map((o) => o.displayName)"
                    label="Document"
                    v-model="selectedCopy"
                    @change="onDocumentChange"
                ></v-select>
                <div
                    style="height: 450px; overflow-y: auto;"
                    class="mt-3"
                    v-if="
                        selectedDocumentCopy.fileURL &&
                            selectedDocumentCopy.numPages &&
                            selectedDocumentCopy.isPdf
                    "
                >
                    <!-- <pdf
                        style="max-height: 450px !important; width: 100%;"
                        :src="rowClicked.fileURL"
                    ></pdf> -->
                    <pdf
                        v-for="i in selectedDocumentCopy.numPages"
                        :key="i"
                        :src="src"
                        :page="i"
                        style="width: 100%;"
                    ></pdf>
                </div>
                <div
                    class="mt-3"
                    v-if="
                        selectedDocumentCopy.fileURL &&
                            selectedDocumentCopy.isImage
                    "
                    style="height: 450px; overflow-y: auto;"
                >
                    <img
                        :src="selectedDocumentCopy.fileURL"
                        style="max-height: 950px !important;"
                    />
                </div>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="copyDocumentDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="copyDocument()"
                    >
                        Copy Document
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="editAccountInfoDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline pt-2"
                    >Edit Account Info</v-card-title
                >
                <v-text-field
                    class="px-3"
                    v-model="emailAddress"
                    :rules="emailRules"
                    ref="emailAddress"
                    label="Email Address"
                ></v-text-field>
                <v-text-field
                    class="px-3"
                    v-model="username"
                    ref="username"
                ></v-text-field>
                <v-text-field
                    class="px-3"
                    v-model="password"
                    ref="password"
                ></v-text-field>
                <v-card-actions class="mr-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="default"
                        @click="editAccountInfoDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveAccountInfo"
                    >
                        save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import moment from "moment";
import { loadOptions } from "../../utils/smLookup.js";
import transactionsComponent from "./YKTransactions.vue";
import payment from "./Payment.vue";
import schedulePayment from "./SchedulePayment.vue";
import balanceDetails from "./BalanceDetails.vue";
import { getDomain } from "../../utils/helpers.js";
import newPaymentMethod from "../Payment/NewPaymentMethod.vue";
import paymentMethods from "../Account/PaymentMethods.vue";
import notes from "../components/Notes.vue";
import axios from "axios";
import pdf from "vue-pdf";
import makePayment from "../Payment/MakePayment.vue";

export default {
    components: {
        balanceDetails,
        paymentMethods,
        notes,
        payment: payment,
        "make-payment": makePayment,
        "schedule-payment": schedulePayment,
        "transactions-list": transactionsComponent,
        newPaymentMethod,
        pdf,
    },
    data() {
        return {
            account: {},
            ykAccount: {},
            voucherAccount: {},

            transactions: [],
            classes: [],
            students: [],
            enrolledStudents: [],
            registrationStatus: [],
            gradesSetup: [],
            pastYearsEnrollmentInfo: [],

            paymentMethods: [],
            documents: [],

            paymentDialog: false,
            newStudentDialog: false,
            newAccountDialog: false,

            transactionsLoading: true,
            balanceLoading: true,

            country: "",
            countries: [],
            originalCountry: "",
            editingCountry: false,
            customCountry: "",

            lunchDocument: false,
            lunchDocumentUrl: "",

            processURL: "api/yk/processPayment",

            uploading: false,
            processing: false,
            printing: false,
            files: [],
            documentTypes: [
                "LUNCH",
                "HEALTH FORM",
                "INSURANCE CARD",
                "HISCYVIS",
            ],
            documentType: "",
            uploadDocumentForStudent: "",
            uploadDocumentDialog: false,

            selectedCopy: "",
            selectedDocumentCopy: {},
            oldDocuments: [],
            copyDocumentForStudent: "",
            copyDocumentRequirment: "",
            copyDocumentDialog: false,

            openDialogForStudent: null,
            printCardsDialog: false,
            newPaymentMethodDialog: false,

            emailCardsDialog: false,
            emailStatementDialog: false,
            emailStatementMessage: "",
            emailAddress: "",
            emailing: false,
            downloading: false,

            includeNotesInEmail: false,

            username: "",
            password: "",

            editAccountInfoDialog: false,

            regID: "",
            currentRegID: "",

            rulesRequired: [(value) => !!value || "Required."],
            countryRules: [(value) => !!value || "Required."],
            emailRules: [
                (value) => !!value || "Required.",
                (value) => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || "Invalid e-mail.";
                },
            ],

            customCountryRules: [(value) => !!value || "Required."],

            notesUrl: "",
        };
    },
    async created() {
        this.load();

        this.savePage();
    },
    computed: {},
    methods: {
        async load() {
            await this.loadRegID();
            //await this.loadYkAccount();
            this.loadAccountAndDocuments();
            await this.loadYkcAccountBilling();
            this.loadGradesSetup();
            this.loadClasses();
            this.loadRegistrationStatus();

            await this.loadTransctions();

            this.loadOldDocuments();
            this.loadSavedCards();
        },
        async savePage() {
            await this.$http.post("api/recentPage/save", {
                accountID: this.$route.params.id,
                page: this.$route.fullPath,
                type: "YKC",
                user: this.$store.state.authentication.user,
            });
        },
        async loadRegID() {
            const regID = await this.$http.get("api/yk/getRegID");

            this.currentRegID = regID;

            if (this.$route.params.reg_id) {
                this.regID = this.$route.params.reg_id.toUpperCase();
            } else {
                this.regID = this.currentRegID.toUpperCase();
            }

            this.notesUrl =
                "api/yk/getNotes?accountID=" +
                this.$route.params.id.trim() +
                "&regID=" +
                this.regID;
        },
        async loadAccountAndDocuments() {
            this.account = await this.$http.get(
                "api/accounts/GetAccount?accountID=" + this.$route.params.id,
            );

            this.emailAddress = this.account.emailAddress;

            this.loadDocuments();
        },
        async loadYkAccount() {
            this.ykAccount = await this.$http.get(
                "api/yk/GetYKCAccount?accountID=" +
                    this.$route.params.id +
                    "&regID=" +
                    this.regID,
            );
        },
        async loadVoucherAccount() {
            const accountID = this.$route.query.voucherAccount
                ? this.$route.query.voucherAccount
                : this.$route.params.id;

            const voucherAccount = await this.$http.get(
                "api/lapidusTransactions/GetAccount?regID=" +
                    this.regID +
                    "&accountID=" +
                    accountID,
            );

            this.voucherAccount = voucherAccount
                ? voucherAccount
                : {
                      available: 0,
                      accountID: accountID,
                  };
        },
        async loadClasses() {
            const classes = await this.$http.get(
                "api/classSetup/get?regID=" + this.regID,
            );
            this.classes = classes;
        },
        async loadTransctions() {
            await this.loadStudents();

            const response = await this.$http.get(
                "api/yk/GetTransactions?accountID=" +
                    this.$route.params.id +
                    "&regID=" +
                    this.regID,
            );

            let transactions = response.map((t) => {
                t.date = t.date;
                t.dateCreated = t.dateCreated ? t.dateCreated : null;
                t.lastUpdated = t.lastUpdated ? t.lastUpdated : null;

                return t;
            });

            const enrolledStudents = await this.$http.get(
                "api/yk/GetEnrolledStudents?accountID=" +
                    this.$route.params.id +
                    "&regID=" +
                    this.regID,
            );

            this.setupRequirments(enrolledStudents);

            this.enrolledStudents = enrolledStudents.map((student) => {
                const studentData = this.students.find(
                    (s) => s.studentID.trim() == student.studentID.trim(),
                );

                student.firstNameH = studentData
                    ? studentData.hebName
                    : "Student Not Found";

                student.registrationStatus = student.isRegistered
                    ? "REGISTERED"
                    : "NOT REGISTERED";

                return student;
            });

            const bills = transactions
                .filter((t) => t.txnType == "D")
                .map((transaction) => {
                    if (!transaction.dayCampID) return transaction;

                    const enrollment = this.enrolledStudents.find(
                        (s) => s.id == transaction.dayCampID,
                    );

                    const student = this.students.find(
                        (s) => s.studentID == enrollment.studentID,
                    );

                    transaction.student = {
                        isEnrolled: true,
                        enrollment: enrollment,
                        studentID: enrollment.studentID,
                        cardPrinted: enrollment.cardPrintDate,
                        chosenClass: this.getClass(enrollment),
                    };

                    if (student) {
                        transaction.student.cardPrinted =
                            enrollment.cardPrintDate;
                        transaction.student.regID = student.regID;
                        transaction.student.nonUTA = student.nonUTA;
                        transaction.student.name = student.engName;
                        transaction.student.engName = student.engName;
                        transaction.student.dob = student.dob;
                        transaction.student.studentID = student.studentID;
                        transaction.student.hebName = student.hebName;
                        transaction.student.class = student.class;
                        transaction.student.branch = student.branch;
                        transaction.student.teacher = student.teacherH;
                        transaction.student.teacher2 = student.teacherH2;
                        transaction.student.callingCardPIN =
                            student.callingCardPin;
                    }

                    return transaction;
                });

            const credits = transactions.filter((t) => t.txnType == "C");

            transactions = bills.concat(credits);

            this.addRunningBalance(transactions);

            this.transactions = transactions;

            this.transactions
                .filter((t) => t.txnType == "C")
                .forEach((transaction) => {
                    if (transaction.payments.length) {
                        transaction.payments.forEach(
                            (p) => (p.expanded = false),
                        );
                    }

                    if (transaction.schedules.length) {
                        transaction.schedules.forEach(
                            (p) => (p.expanded = false),
                        );
                    }
                });

            this.transactionsLoading = false;

            this.loadClickedStudent();
            this.$forceUpdate();
        },
        addRunningBalance(transactions) {
            let totalBalance = 0;

            if (this.ykAccount.previousBalance !== 0) {
                transactions.unshift({
                    description: "Previous Balance",
                    amount: this.ykAccount.previousBalance,
                    calcAmount: this.ykAccount.previousBalance,
                    balance: this.ykAccount.previousBalance,
                    txnType: "D",
                    student: {
                        enrollment: {},
                    },
                });
            }

            transactions.forEach((transaction) => {
                let balance = totalBalance;

                const amount =
                    this.isError(transaction) ||
                    this.isDeclined(transaction) ||
                    this.isPastDue(transaction)
                        ? 0
                        : transaction.calcAmount;

                balance = totalBalance + amount;

                totalBalance = balance;

                transaction.balance = balance.toFixed(2);
            });
        },
        getRateCode() {
            const transaction = this.transactions.find((t) =>
                t.description.startsWith("Yeshiva Ketana Camp"),
            );

            return transaction ? transaction.student.enrollment.rateCode : "";
        },
        getClass(student) {
            if (student.classID == null) return "";

            return this.classes.find((c) => c.classID == student.classID);
        },
        async loadStudents() {
            const students = await this.$http.get(
                `api/yk/getStudents?accountID=${
                    this.$route.params.id
                }&regID=RG${this.regID.replace(/^\D+/g, "")}`,
            );

            this.students = students;
        },

        async loadRegistrationStatus() {
            const registrationStatus = await this.$http.get(
                `api/yk/getRegistrationStatus?accountID=${
                    this.$route.params.id
                }&regID=${this.regID}`,
            );

            this.registrationStatus = registrationStatus;
        },
        async loadGradesSetup() {
            this.gradesSetup = await this.$http.get("api/yk/getGradesSetup");
        },
        async loadYkcAccountBilling() {
            const info = await this.$http.get(
                `api/yk/getEnrollmentDetailsPerYear?accountID=${
                    this.$route.params.id
                }`,
            );

            this.ykAccount = info.find((a) => a.regID == this.regID).ykAccount;
            this.pastYearsEnrollmentInfo = info;
            this.balanceLoading = false;
        },
        hasDayCamp(student) {
            return this.gradesSetup.find((g) => g.grade == student.class)
                .isCountryAvail;
        },
        editAccountInfo() {
            this.emailAddress = this.ykAccount.emailAddress;
            this.username = this.ykAccount.jlWebUsername;
            this.password = this.ykAccount.jlWebPassword;

            this.editAccountInfoDialog = true;
        },
        async saveAccountInfo() {
            if (!this.$refs.emailAddress.validate(true)) return;

            try {
                this.processing = true;

                await this.$http.post("api/yk/saveAccountInfo", {
                    uTAAccountId: this.account.accountID,
                    emailAddress: this.emailAddress,
                    jLWebUsername: this.username,
                    jLWebPassword: this.password,
                });

                this.processing = false;
                this.editAccountInfoDialog = false;

                this.load();

                this.$notify({
                    text: "Changes Saved",
                    group: "notification",
                    type: "success",
                });
            } catch (e) {
                this.processing = false;
            }
        },
        async loadOldDocuments() {
            const response = await this.$http.get(
                "api/YKCDocuments/getForAccount?accountID=" +
                    this.$route.params.id,
            );

            this.oldDocuments = response
                .filter((r) => r.regID != this.regID)
                .map((d) => {
                    d.category + " - " + d.regID;

                    return d;
                });
        },
        async loadSavedCards() {
            const paymentMethods = await this.$http.get(
                "api/payments/getSavedCards?accountID=" + this.$route.params.id,
            );

            this.paymentMethods = paymentMethods
                .map((method) => {
                    method.cardInfo =
                        (method.cardType ? method.cardType : "") +
                        " - " +
                        method.cardNumberLast5;

                    method.editing = false;
                    method.processing = false;

                    return method;
                })
                .sort((a, b) => {
                    if (Date.parse(a.lastUsed) > Date.parse(b.lastUsed))
                        return -1;
                    if (Date.parse(a.lastUsed) < Date.parse(b.lastUsed))
                        return 1;
                    return 0;
                });
        },
        async loadCountries() {
            this.countries = await loadOptions("country");
        },
        async loadDocuments() {
            if (!this.account.nonUTA) {
            }

            this.documents = (await this.$http.get(
                "api/yk/getDocuments?accountID=" +
                    this.account.accountID +
                    "&regID=" +
                    this.regID,
            )).map((doc) => {
                doc.uploadedOn = moment(doc.uploadedOn).format("LLL");

                return doc;
            });
        },
        async loadClickedStudent() {
            if (!this.$route.query.studentID) return;

            const enrollment = this.enrolledStudents.find(
                (s) => s.studentID == this.$route.query.studentID,
            );

            const student = this.students.find(
                (s) => s.studentID == this.$route.query.studentID,
            );

            this.openDialogForStudent = {
                isEnrolled: true,
                enrollment: enrollment,
                studentID: student.studentID,
                nonUTA: student.nonUTA,
                name: student.engName,
                engName: student.engName,
                dob: student.dob,
                studentID: student.studentID,
                hebName: student.hebName,
                class: student.class,
                chosenClass: this.getClass(enrollment),
            };
        },
        getCountry() {
            if (!this.country) return "";

            return this.country.countryDescription;
        },
        validateCountry() {
            const validations = [this.$refs.country.validate(true)];

            if (this.country == "Other") {
                validations.push(this.$refs.customCountry.validate(true));
            }

            return validations.every(Boolean);
        },
        hasDocumetToCopy(requirment) {
            let documentType = "";

            switch (requirment.description) {
                case "Health Form":
                    documentType = "HEALTH FORM";
                    break;
                case "Lunch Document":
                    documentType = "LUNCH";
                    break;
                case "Hiscyvis Letter":
                    documentType = "HISCYVIS";
                    break;
                case "Insurance / Medicaid Card":
                    documentType = "INSURANCE CARD";
                    break;
            }

            return this.oldDocuments.includes(
                (d) => d.category == documentType,
            );
        },
        onDocumentChange(value) {
            this.selectedDocumentCopy = this.oldDocuments.find(
                (d) => d.displayName == this.selectedCopy,
            );

            selectedDocumentCopy.isPdf = this.isPdf(selectedDocumentCopy);
            selectedDocumentCopy.isImage = this.isImage(selectedDocumentCopy);
            selectedDocumentCopy.numPages = "";

            const loadingTask = pdf.createLoadingTask(
                selectedDocumentCopy.fileURL,
            );

            const src = loadingTask;

            src.promise.then((pdf) => {
                selectedDocumentCopy.numPages = pdf.numPages;
            });
        },
        isPdf(doc) {
            return ["pdf", "PDF"].includes(doc.fileURL.split(".").pop());
        },
        isImage(doc) {
            return ["jpg", "jpeg", "png", "tif", "JPG", "JPEG"].includes(
                doc.fileURL.split(".").pop(),
            );
        },
        openCopyDocumentDialog(student, requirment) {
            this.copyDocumentForStudent = student;
            this.copyDocumentRequirment = requirment;

            this.copyDocumentDialog = true;
        },
        openUploadDocumentDialog(student, requirment) {
            switch (requirment.description) {
                case "Health Form":
                    this.documentType = "HEALTH FORM";
                    break;
                case "Lunch Document":
                    this.documentType = "LUNCH";
                    break;
                case "Hiscyvis Letter":
                    this.documentType = "HISCYVIS";
                    break;
                case "Insurance / Medicaid Card":
                    this.documentType = "INSURANCE CARD";
                    break;
            }

            this.uploadDocumentForStudent = student;

            this.uploadDocumentDialog = true;
        },
        async copyDocument() {
            try {
                if (!this.selectedCopy) {
                    return this.$notify({
                        text: "Please Select A Document.",
                        group: "notification",
                        type: "error",
                    });
                }

                this.processing = true;

                await this.$http.post("api/YKCDocuments/CopyDocument", {
                    documentID: this.oldDocuments.find(
                        (d) => d.displayName == this.selectedCopy,
                    ).documentID,
                    user: this.$store.state.authentication.user,
                    regID: this.currentRegID,
                });

                this.processing = false;
                this.copyDocumentDialog = false;

                this.$notify({
                    text: "Document copied",
                    group: "notification",
                    type: "success",
                });

                this.refresh();
            } catch (e) {
                this.processing = false;
            }
        },
        closeUploadDocumentDialog(student) {
            this.uploadDocumentDialog = false;
            this.files = [];
        },
        pickFile() {
            this.$refs.files.value = "";

            this.$refs.files.click();
        },
        async onFilePicked(e, student) {
            this.uploading = true;

            const files = e.target.files;

            if (!files) return;

            this.files = files;

            this.uploading = false;
        },
        async saveDocument() {
            if (
                !this.$refs.documentType.validate(true) ||
                (Array.isArray(this.documentType) && !this.documentType.length)
            ) {
                this.$notify({
                    group: "notification",
                    text: "Missing Document Type",
                    type: "error",
                });

                return;
            }

            this.processing = true;

            try {
                var formData = new FormData();

                formData.append("image", this.files[0]);

                const studentID = this.uploadDocumentForStudent
                    ? this.uploadDocumentForStudent.studentID
                    : this.transactions.find((t) => t.student).student
                          .studentID;

                await this.$http.post(
                    "api/yk/UploadFile?accountID=" +
                        this.account.accountID +
                        "&studentID=" +
                        studentID.trim() +
                        "&documentType=" +
                        this.documentType +
                        "&user=" +
                        this.$store.state.authentication.user +
                        "&regID=" +
                        this.regID,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    },
                );

                this.processing = false;
                this.uploadDocumentDialog = false;
                this.files = [];
                this.documentType = [];

                this.load();
            } catch (e) {
                this.processing = false;
            }
        },
        openPaymentModal({ countryVoucher = false }) {
            this.paymentDialog = true;

            if (countryVoucher) {
                const types = this.$refs.paymentDialog.getPaymentTypes();
                const type = types.find((t) => t.startsWith("Country Voucher"));

                this.$refs.paymentDialog.type = type;
                this.$refs.paymentDialog.amount = type.replace(/\D/g, "");
                this.$refs.paymentDialog.paymentTypeDisabled = true;
            }
        },
        closePaymentModal() {
            this.$refs.paymentDialog.clear();

            this.paymentDialog = false;
        },
        onNewStudentCreated() {
            this.newStudentDialog = false;

            this.load();
        },
        closeNewStudentModal() {
            this.newStudentDialog = false;
        },
        closeNewAccountModal() {
            this.newAccountDialog = false;
        },
        async editAccount() {
            const newAccountPrefill = await this.$http.get(
                "api/lapidusDayCamp/getNewAccount?accountID=" +
                    this.account.accountID,
            );

            this.$refs.newAccount.prefill(newAccountPrefill);

            this.newAccountDialog = true;
        },
        onNewAccountCreated(account) {
            this.load();
        },
        hasUnregisteredStudent() {
            return this.getStudents().some((s) => !s.enrollment.isRegistered);
        },
        printCards() {
            if (this.hasUnregisteredStudent()) {
                return this.$notify({
                    text: "Can't print cards when student not registered",
                    group: "notification",
                    type: "error",
                });
            }
            // if (
            //     this.studentsMissingLunchDocuments().length ||
            //     this.studentsMissingHealthFormDocuments().length
            // ) {
            //     return (this.printCardsDialog = true);
            // }

            this.print();
        },
        studentsMissingLunchDocuments() {
            return this.transactions.filter(
                (transaction) =>
                    transaction.txnType == "D" &&
                    transaction.description.startsWith("Yeshiva Ketana Camp") &&
                    !transaction.student.enrollment.lunchDoc,
            );
        },
        getHealthFormStatus() {
            const students = this.transactions
                .filter(
                    (transaction) =>
                        transaction.txnType == "D" &&
                        transaction.description.startsWith(
                            "Yeshiva Ketana Camp",
                        ),
                )
                .map((s) => s.student);

            return students.map((student) => {
                const doc = this.documents
                    .filter((s) => s.studentID)
                    .find(
                        (d) =>
                            d.category.toUpperCase() == "HEALTH FORM" &&
                            d.studentID.trim() == student.studentID.trim(),
                    );

                return {
                    name: "Health Form Status - " + student.hebName,
                    status: doc ? "UPLOADED" : "MISSING",
                };
            });
        },
        getRegStatus() {
            const students = this.transactions
                .filter(
                    (transaction) =>
                        transaction.txnType == "D" &&
                        transaction.description.startsWith(
                            "Yeshiva Ketana Camp",
                        ),
                )
                .map((s) => s.student);

            return students.map((student) => {
                const status = this.registrationStatus.find(
                    (r) => r.studentID.trim() == student.studentID.trim(),
                );

                return {
                    name: "Registration Status - " + student.hebName,
                    status: status.registrationStatus,
                };
            });
        },
        studentsMissingHealthFormDocuments() {
            const students = this.transactions.filter(
                (transaction) =>
                    transaction.txnType == "D" &&
                    transaction.description.startsWith("Yeshiva Ketana Camp"),
            );

            return students.filter(
                (t) =>
                    !this.documents
                        .filter(
                            (d) => d.category.toUpperCase() == "HEALTH FORM",
                        )
                        .map((d) => d.studentID)
                        .includes(t.student.studentID.trim()),
            );
        },
        getStudents() {
            return this.transactions
                .filter(
                    (t) =>
                        t.txnType == "D" &&
                        t.description.startsWith("Yeshiva Ketana Camp"),
                )
                .map((t) => t.student);
        },
        setupRequirments(enrolledStudents) {
            let number = 0;

            enrolledStudents.forEach((student) => {
                student.requirments = [
                    {
                        description: "Lunch Document",
                        status: this.ykAccount.lunchDocumentStatus,
                        showRequirment:
                            this.ykAccount.lunchDocumentStatus == "MISSING" ||
                            this.ykAccount.lunchDocumentStatus == "Application",
                    },
                    {
                        description: "Health Form",
                        status: this.getRequirmentStatus(
                            "Health Form",
                            student,
                        ),
                        showRequirment: true,
                    },
                    {
                        description: "Insurance / Medicaid Card",
                        status: this.getRequirmentStatus(
                            "Insurance / Medicaid Card",
                            student,
                        ),
                        showRequirment: true,
                    },
                    {
                        description: "Hiscyvis Letter",
                        status: this.getRequirmentStatus(
                            "Hiscyvis Letter",
                            student,
                        ),
                        showRequirment: true,
                    },
                ];
            });
        },
        getRequirmentStatus(requirment, student) {
            if (!this.documents.length) return "MISSING";

            if (requirment == "Lunch Document") {
                const docs = this.documents.filter(
                    (d) =>
                        d.accountID == student.familyID.trim() &&
                        d.category.toUpperCase() == "LUNCH",
                );

                const doc = docs.find((d) =>
                    ["APPROVED", "UPLOADED"].includes(d.status),
                )
                    ? docs.find((d) =>
                          ["APPROVED", "UPLOADED"].includes(d.status),
                      )
                    : docs[0];

                return doc ? doc.status : "MISSING";
            } else if (requirment == "Insurance / Medicaid Card") {
                const docs = this.documents.filter(
                    (d) =>
                        d.studentID == student.studentID.trim() &&
                        d.category.toUpperCase() == "INSURANCE CARD",
                );

                const doc = docs.find((d) =>
                    ["APPROVED", "UPLOADED"].includes(d.status),
                )
                    ? docs.find((d) =>
                          ["APPROVED", "UPLOADED"].includes(d.status),
                      )
                    : docs[0];

                return doc ? doc.status : "MISSING";
            } else if (requirment == "Hiscyvis Letter") {
                const docs = this.documents.filter(
                    (d) =>
                        d.studentID == student.studentID.trim() &&
                        d.category.toUpperCase() == "HISCYVIS",
                );

                const doc = docs.find((d) =>
                    ["APPROVED", "UPLOADED"].includes(d.status),
                )
                    ? docs.find((d) =>
                          ["APPROVED", "UPLOADED"].includes(d.status),
                      )
                    : docs[0];

                return doc ? doc.status : "MISSING";
            } else {
                const docs = this.documents.filter(
                    (d) =>
                        d.studentID == student.studentID.trim() &&
                        d.category.toUpperCase() == "HEALTH FORM",
                );

                const doc = docs.find((d) =>
                    ["APPROVED", "UPLOADED"].includes(d.status),
                )
                    ? docs.find((d) =>
                          ["APPROVED", "UPLOADED"].includes(d.status),
                      )
                    : docs[0];

                return doc ? doc.status : "MISSING";
            }
        },
        print() {
            // window.location =
            //     getDomain() +
            //     "/api/yk/downloadCards?accountID=" +
            //     this.account.accountID;

            this.printCardsDialog = false;

            this.printing = true;

            axios({
                url:
                    getDomain() +
                    "/api/yk/downloadCards?accountID=" +
                    this.account.accountID,
                method: "GET",
                responseType: "blob", // important
            })
                .then((response) => {
                    this.printing = false;

                    const url = window.URL.createObjectURL(
                        new Blob([response.data]),
                    );
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "YK_RegCards.pdf"); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(() => {
                    this.printing = false;
                });
        },
        emailCards() {
            this.emailCardsDialog = true;
        },
        async sendEmail() {
            if (!this.$refs.email.validate()) return;

            if (this.hasUnregisteredStudent()) {
                return this.$notify({
                    text: "Can't print cards when student not registered",
                    group: "notification",
                    type: "error",
                });
            }

            this.emailing = true;

            await this.$http.post(
                "api/yk/emailCards?accountID=" +
                    this.account.accountID +
                    "&emailAddress=" +
                    this.emailAddress,
            );

            this.$notify({
                text: "Email Sent",
                group: "notification",
                type: "success",
            });

            this.emailing = false;

            this.emailCardsDialog = false;
            this.emailAddress = this.account.emailAddress
                ? this.account.emailAddress.trim()
                : this.account.emailAddress;
        },
        getRegisteredWeeks(transaction) {
            const weeks = Object.keys(transaction.student.enrollment)
                .map((key) => {
                    if (
                        !key.startsWith("week") ||
                        !transaction.student.enrollment[key]
                    )
                        return;

                    return key.substring(4);
                })
                .filter(Boolean);

            return weeks.join(", ");
        },
        closeNewPaymentMethodDialog() {
            this.newPaymentMethodDialog = false;
        },
        updateSelectedPaymentMethod(paymentMethod) {
            paymentMethod.cardInfo =
                paymentMethod.cardType + " - " + paymentMethod.cardNumberLast5;

            this.paymentMethods.push(paymentMethod);
        },
        getStatementDescription(transaction) {
            let description =
                transaction.txnType == "D" &&
                transaction.description != "Previous Balance"
                    ? (transaction.student ? transaction.student.engName : "") +
                      " - " +
                      transaction.description
                    : transaction.description;

            if (
                transaction.txnType == "D" &&
                transaction.student &&
                transaction.student.enrollment.regType == "CUSTOM"
            ) {
                description += "Weeks: " + this.getRegisteredWeeks(transaction);
            }

            if (transaction.txnType == "C" && transaction.receiptNumber) {
                description += " - Receipt #" + transaction.receiptNumber;
            }

            if (
                !description.startsWith("Refund") &&
                !description.startsWith("Void") &&
                transaction.txnType == "C" &&
                transaction.calcAmount > 0
            ) {
                description = "Reverse - " + description;
            }

            if (this.isError(transaction)) {
                description += " - Error";
            }

            if (this.isDeclined(transaction)) {
                description += " - Declined";
            }

            if (this.isPastDue(transaction)) {
                description += " - Past Due";
            }

            return description;
        },
        createStatement() {
            let html = `<!DOCTYPE html>
            <html>
            <head>
            <style>
                table {
                  font-family: arial, sans-serif;
                  border-collapse: collapse;
                  width: 100%;
                  font-size: 28px !important;
                }

                td, th {
                  border: 1px solid #dddddd;
                  text-align: left;
                  padding: 16px;
                  font-size: 25px !important;
                }
                .text-table td, table {
                    border: none;
                    padding: 0px;
                    background-color: #fff;
                    font-size: 25px !important;
                }

                .account-info {
                    font-family: arial, sans-serif;
                    text-align: left;
                    font-weight: 200;
                    margin-bottom: 30px;
                    font-size: 25px !important;
                }

                tr:nth-child(even) {
                  background-color: #dddddd;
                }
                .regular-text {
                    margin-bottom: 8px;
                    margin-top: 0px;
                    font-size: 36px !important;
                }
            </style>
            <div style="margin-right: 64px !important">
            <img src="https://utaw.blob.core.windows.net/images/ykletterhead2.jpg">
            </div>
            </head>
            <body style="padding: 32px; margin-right: 32px; margin-left: 32px">

            <p style="margin-top: 32px; margin-bottom: 20px;">&nbsp;</p>

            <div class="account-info">
            <p class="regular-text"><strong>${this.account.name}</strong></p>
            <p class="regular-text"><strong>Address: </strong>${
                this.account.address1
            }</p>
            <p class="regular-text"><strong>Phone: </strong>${
                this.account.homePhone
            }</p>`;

            if (this.ykAccount.emailAddress) {
                html += `<p class="regular-text"><strong>Email: </strong>${
                    this.ykAccount.emailAddress
                }</p>`;
            }

            html += `</div>

            <table style="margin-top: 20px; border-collapse: collapse; width: 100%;" border="1">
            <tr>
                <th>Date</th>
                <th>Description</th>
                <th>Charges</th>
                <th>Payments</th>
                <th>Balance</th>
            </tr>
            <tbody>`;

            const transactions = JSON.parse(JSON.stringify(this.transactions));

            // transactions.splice(0, 0, {
            //     date: moment().format("L"),
            //     txnType: this.ykAccount.previousBalance < 0 ? "C" : "D",
            //     description: "Previous Balance",
            //     calcAmount: this.ykAccount.previousBalance,
            // });

            let totalBalance = 0;

            transactions.forEach((transaction) => {
                let balance = totalBalance;

                const amount =
                    this.isError(transaction) ||
                    this.isDeclined(transaction) ||
                    this.isPastDue(transaction)
                        ? 0
                        : transaction.calcAmount;

                balance = totalBalance + amount;
                // (transaction.txnType === "D"
                //     ? transaction.calcAmount
                //     : -transaction.calcAmount);

                totalBalance = balance;

                html += `<tr>
                    <td>${moment(transaction.date).format("L")}</td>
                    <td>${this.getStatementDescription(transaction)}</td>
                    <td><strong>${
                        transaction.txnType == "D"
                            ? "$" +
                              (transaction.calcAmount
                                  ? transaction.calcAmount
                                  : 0
                              ).toFixed(2)
                            : "$0.00"
                    }</strong></td>
                    <td><strong>${
                        transaction.txnType == "C"
                            ? (transaction.calcAmount
                                  ? transaction.calcAmount
                                  : 0
                              ).toFixed(2)
                            : "$0.00"
                    }</strong></td><td><strong>${balance.toFixed(
                    2,
                )}</strong></td>
                </tr>`;
            });

            html += `</tbody></table>
                <p>&nbsp;</p>
                <table class="text-table" style="width: 30%; margin-right: 10px;" align="right">
                <tr>
                <td><p class="regular-text">Previous Balance:</p></td>
                    <td style="text-align: right;"><p class="regular-text"><strong>$${
                        this.ykAccount.previousBalance
                    }</strong></p></td>
                </tr>
                <td><p class="regular-text">Billed:</p></td>
                    <td style="text-align: right;"><p class="regular-text"><strong>$${
                        this.ykAccount.debit
                    }</strong></p></td>
                </tr>
                <td><p class="regular-text">Paid:</p></td>
                    <td style="text-align: right;"><p class="regular-text"><strong>$${
                        this.ykAccount.paid
                    }</strong></p></td>
                </tr>
                <td><p class="regular-text">Credit:</p></td>
                    <td style="text-align: right;"><p class="regular-text"><strong>$${
                        this.ykAccount.credit
                    }</strong></p></td>
                </tr>
                <td><p class="regular-text">Total Balance:</p></td>
                    <td style="text-align: right;"><p class="regular-text"><strong>$${
                        this.ykAccount.balance
                    }</strong></p></td>
                </tr>
                </table>

                </body>
            </html>`;

            return html;
        },
        isVoided(transaction) {
            return (
                transaction.txnType == "C" &&
                transaction.payments &&
                transaction.payments.some((p) => p.isVoided)
            );
        },
        isDeclined(transaction) {
            if (transaction.txnType != "C") return;

            return (
                transaction.paymentStatus &&
                transaction.paymentStatus.toUpperCase() == "DECLINED"
            );

            // return (
            //     (transaction.payment &&
            //         transaction.payment.status == "DECLINED") ||
            //     (transaction.schedule &&
            //         transaction.schedule.status == "Declined")
            // );
        },
        isError(transaction) {
            if (transaction.txnType != "C") return;

            return (
                transaction.paymentStatus &&
                transaction.paymentStatus.toUpperCase() == "ERROR"
            );

            // return (
            //     (transaction.payment &&
            //         transaction.payment.status == "ERROR") ||
            //     (transaction.schedule &&
            //         transaction.schedule.status.startsWith("Error"))
            // );
        },
        isPastDue(transaction) {
            const today = new Date();

            if (
                this.getPaymentType(transaction) == "Cash/Check" ||
                (transaction.schedules &&
                    transaction.schedules.some((s) => s.status == "Scheduled"))
            ) {
                return (
                    new Date(transaction.date) < today &&
                    (transaction.paymentStatus == "SCHEDULED" ||
                        !transaction.receiptNumber)
                );
            }
        },
        getPaymentType(transaction) {
            if (transaction.txnType == "D") return;

            if (transaction.description.startsWith("CK")) return "ACH";

            if (transaction.description.startsWith("Country Voucher"))
                return "Country Voucher";

            return !transaction.description.includes(" ")
                ? transaction.description
                : transaction.description.substr(
                      0,
                      transaction.description.indexOf(" "),
                  );
        },
        async printStatement() {
            // const newWindow = window.open(
            //     "",
            //     "Account Statement",
            //     "width=1600, height=1200"
            // );

            // newWindow.document.write(this.createStatement());

            const html = this.createStatement();

            const url = getDomain() + "/api/yk/downloadLetter";

            this.downloading = true;

            axios({
                url: url,
                data: {
                    html,
                },
                method: "POST",
                responseType: "blob", // important
            })
                .then((response) => {
                    this.downloading = false;

                    const url = window.URL.createObjectURL(
                        new Blob([response.data]),
                    );
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "YK_Statement.pdf"); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(() => {
                    this.downloading = false;
                });
        },
        openEmailStatementDialog() {
            this.emailStatementMessage =
                "Attached is your account statement.\n\n\n<br>" +
                "\n<br>" +
                "\n<br>" +
                `<a href="camp.yksw.org">Access your Account Portal</a>` +
                "\n<br>" +
                "User Name: " +
                this.ykAccount.jlWebUsername +
                "\n<br>" +
                "Password:  " +
                this.ykAccount.jlWebPassword +
                "\n<br>" +
                "Account ID:  " +
                this.account.accountID;

            this.emailStatementDialog = true;
        },
        openNewCreditCardModal() {
            this.newPaymentMethodDialog = true;
        },
        async emailStatement() {
            if (!this.$refs.emailStatement.validate(true)) return;

            this.emailing = true;

            try {
                await this.$http.post("api/yk/emailLetter", {
                    emailAddress: this.emailAddress,
                    html: this.createStatement(),
                    subject: "Camp Yeshiva Ketana Statement",
                    message:
                        this.emailStatementMessage +
                        (this.includeNotesInEmail
                            ? "<br><br>" + this.getNotesForEmail()
                            : ""),
                    isHtml: true,
                });

                this.$notify({
                    text: "Email Sent",
                    group: "notification",
                    type: "success",
                });

                this.emailStatementDialog = false;
            } catch (e) {
            } finally {
                this.emailing = false;
            }
        },
        isBigScreenSize() {
            return window.innerWidth > 1400;
        },
        getNotesForEmail() {
            if (!this.$refs.notes) return "";

            let html = `<div style="margin-bottom: 8px; font-weight: 500; font-size: 22px;">Notes</div>`;

            this.$refs.notes.getNotes().forEach((note) => {
                html += `<div>${moment(note.date).format(
                    "MM/DD/YYYY h:mm:ss A",
                )} <strong>${note.byUser}</strong> ${note.note1}<div><hr>`;
            });

            return html;
        },
    },
};
</script>
<style>
.website-link-text {
    color: rgb(32, 166, 237);
    display: inline-block;
    word-wrap: break-word;
    width: 100%;
}
</style>
